module.exports = __webpack_public_path__ + "img/电梯动画17.5c9185d7.png";